import scheduledOrders from './list/sagas'
import importScheduledOrders from './import/sagas'

export default [scheduledOrders, importScheduledOrders]
